import { Formik } from 'formik';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Button } from 'react-bootstrap';
import LoadingOverlay from '../LoadingOverlay';
import PropertyForm, { PropertyFormValidater } from './PropertyForm';

function AddProperty(props) {
  const newPropertyIdentifier = props.newProperty?.data?.identifier;
  const newPropertyName = props.newProperty?.data?.name;

  return (
    <Formik
      initialValues={{
        // react-select options (it's not possible to use outside props)
        users: props.users,
        regions: props.regions,
        propertyKeyContacts: props.propertyKeyContacts,

        // Property Key Contact
        add_key_contact: false,
        add_key_contact_tab: 'details',
        property_key_contact: '',
        new_property_key_contact: {
          user_type: 'fruition',
          user: '',
          name: '',
          email: '',
          phone_number: ''
        },

        // In the format that react-select requires
        region: '',

        identifier: newPropertyIdentifier || '',
        name: newPropertyName || '',
        boundry: '',
        hectares: '',
        add_staff: false
      }}
      validate={PropertyFormValidater}
      onSubmit={(values, actions) => {
        // Build the json object to send to the API
        const postValues = {
          region_id: values.region.value,
          identifier: values.identifier,
          name: values.name,
          boundry: values.boundry,
          hectares: values.hectares,
          add_staff: values.add_staff
        };

        // Use existing property key contact was selected
        if (values.property_key_contact) {
          postValues.property_key_contact_id =
            values.property_key_contact.value;
        }

        // Create a new property key contact using a user id
        else if (values.new_property_key_contact.user) {
          postValues.new_property_key_contact = {
            user_type: values.new_property_key_contact.user_type,
            user_id: values.new_property_key_contact.user.value
          };
        }

        // Create a new property key contact using text fields
        else {
          postValues.new_property_key_contact = {
            name: values.new_property_key_contact.name,
            email: values.new_property_key_contact.email,
            phone_number: values.new_property_key_contact.phone_number
          };
        }

        fetch(process.env.REACT_APP_PROPERTIES_API_URL + 'api/properties', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: 'Bearer ' + props.bearerToken,
            service: 'fruition',
            SeasonalDatabase: props.selectedDatabase
          },
          body: JSON.stringify(postValues)
        })
          .then((res) => {
            if (res.ok)
              res.json().then((data) => {
                if (data) {
                  props.add(data);
                }
                
              });
            else if (res.status === 422)
              res.json().then((data) => {
                if (data.errors)
                  Object.keys(data.errors).forEach((key) => {
                    actions.setFieldError(key, data.errors[key][0]);
                  });

                actions.setSubmitting(false);
              });
            else if (res.status === 401) props.refreshBearerToken();
            else throw Error(res.statusText);
          })
          .catch((err) => {
            if (process.env.NODE_ENV === 'development') console.error(err);
            actions.setSubmitting(false);
          });
      }}
    >
      {(props) => (
        <Fragment>
          <PropertyForm {...props} />
          <Button varient='primary' type='button' onClick={props.handleSubmit}>
            Submit
          </Button>
          {props.isSubmitting ? <LoadingOverlay /> : null}
        </Fragment>
      )}
    </Formik>
  );
}

AddProperty.propTypes = {
  // Authentication
  selectedDatabase: PropTypes.string,
  bearerToken: PropTypes.string.isRequired,
  refreshBearerToken: PropTypes.func.isRequired,

  // Property
  add: PropTypes.func.isRequired,

  // Other data
  users: PropTypes.array.isRequired,
  regions: PropTypes.array.isRequired,
  propertyKeyContacts: PropTypes.array.isRequired,
  newProperty: PropTypes.object.isRequired
};

export default observer(AddProperty);
